











































































































import _ from "lodash";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import metadata from '@/store/modules/metadata';

@Component({
  components: {
    FontAwesomeIcon,
  },
})
export default class Table extends Vue {
  @Prop({ default: [] }) rows!: Array<any>;
  @Prop({ default: [] }) checkedRows!: Array<any>;
  @Prop({ default: 10 }) pageSize!: number;

  page = 0;
  topIndex!: number;
  bottomIndex!: number;
  internalChange = false;

  selectedId = null;
  titles = [
    {
      prop: "s3FileName",
      label: "Name",
    },
    {
      prop: "uploadedTimestamp",
      label: "Uploaded",
    },
    {
      prop: "uid",
      label: "UID",
    },
  ];

  toggleCheck(event: any, row: any) {
    event.stopPropagation();
    this.$emit('toggle-check', row);
  }

  isChecked(id: any) {
    return this.checkedRows.indexOf(id) > -1;
  }

  mounted() {
    if (!!this.rows && this.rows.length > 0) {
      this.bottomIndex = 0;
      this.topIndex =
        this.rows.length < this.pageSize ? this.rows.length : this.pageSize;
    } else {
      this.bottomIndex = -1;
      this.topIndex = -1;
    }
  }

  beforeUpdate() {
    if (!this.internalChange) {
      const index = this.rows.findIndex((e) => e.id === this.selectedId);
      this.page = index > -1 ? Math.floor(index / this.pageSize) : 0;
    }
    this.internalChange = false;
  }

  get currentPage() {
    this.bottomIndex = this.pageSize * this.page;
    this.topIndex = this.pageSize * (this.page + 1);

    this.topIndex =
      this.topIndex < this.rows.length ? this.topIndex : this.rows.length;
    return this.rows.slice(this.bottomIndex, this.topIndex);
  }

  get sortSettings() {
    return metadata.sortSettings;
  }

  isNextPage() {
    return this.topIndex < this.rows.length;
  }

  nextPage() {
    if (this.isNextPage()) {
      this.internalChange = true;
      this.page++;
    }
  }

  isPreviousPage() {
    return this.bottomIndex > 0;
  }

  previousPage() {
    if (this.isPreviousPage()) {
      this.internalChange = true;
      this.page--;
    }
  }

  async loadOlderMetadata() {
    const startingVideoCount = metadata.filtered.length;

    await metadata.getPrevMetadata();

    const endingVideoCount = metadata.filtered.length;
    const loadedVideos = endingVideoCount - startingVideoCount;

    this.$toasted.show(`Loaded ${loadedVideos} Videos`, {
      position: 'top-left',
      duration: 3000,
    });
  }

  reverseSorted() {
    return !!this.sortSettings && this.sortSettings.reverse;
  }

  isSortedBy(prop: string) {
    return !!this.sortSettings && this.sortSettings.key == prop;
  }

  sortBy(key: string) {
    metadata.sortBy(key);
  }

  selectRow(row: any) {
    this.selectedId = row.id === this.selectedId ? null : row.id;
    this.$emit("select", this.selectedId);
  }

  isSelected(row: any) {
    return row.id === this.selectedId;
  }

  isFlagged(row: any) {
    return this.rows.find((e) => e.id === row.id).flagged;
  }

  flag(event: any, row: any) {
    event.stopPropagation();
    if (!this.isFlagged(row)) {
      this.$emit("flag", row.id);
    }
  }
}
